import moment from 'moment';

function createFetchCache(key, cacheOption = { duration: 1, unit: 'days' }) {
    const get = () => {
        try {
            const raw = localStorage.getItem(key);
            if (!raw) return { data: [], expiredAt: null, isExpired: true };

            const value = JSON.parse(raw);
            const expiredAt = value?.expiredAt ? moment(value.expiredAt) : null;
            const isExpired = !expiredAt || moment().isAfter(expiredAt);

            return {
                data: isExpired ? [] : value.data || [],
                expiredAt: isExpired ? null : expiredAt,
                isExpired,
            };
        } catch {
            return { data: [], expiredAt: null, isExpired: true };
        }
    };

    /** @param {object[]} data */
    const set = (data = []) => {
        const { duration, unit } = cacheOption;
        const expiredAt = moment().add(duration, unit).toISOString();
        localStorage.setItem(key, JSON.stringify({ data, expiredAt }));
    };

    // Enable fetch only if expiredAt is null (means expired) or no data
    const enabled = () => {
        const { isExpired } = get();
        return isExpired;
    };

    return () => ({ get, set, enabled });
}

export default createFetchCache;
